import { Player } from "./project-player";
import { PageRequest } from "../pageRequest";
import { PageResponse } from "../pageResponse";
import { Transaction, Session } from ".";

export enum MatchEvent {
    FINISHED = 'FINISHED',
    RUNNING = 'RUNNING'
}


export interface Match {
    id?: string;
    creationdate?: Date;
    updatedate?: Date;
    enddate?: Date;
    gameMatchEntries: MatchEntry[];
    transaction?: Transaction;
    player?: Player;
    session?: Session;
    matchId?: string;
    externalGameId?: string;
    status?: string;
}

export interface MatchEntry {
    id: string;
    session: Session;
}

export interface MatchInfo {
    startTime?: Date;
    endTime?: Date;
    matchId?: string;
    playerCount?: number;
    status?: string;
    branchName?: string;

    branchLink?: string[];
    matchLink?: string[];
}

export class MatchResponse extends PageResponse {
    content: Match[];
}

export class MatchInfoPageRequest extends PageRequest {
    event?: string;
    matchId?: string;
}

export class MatchInfoResponse extends PageResponse {
    content: MatchInfo[];
}

